module.exports = __webpack_public_path__ + "img/mingyong74.43573ed0.png";